import { WorkflowRunSteps } from 'components/workflows/workflow_steps';

const WorkflowRunStepsPage = () => {
  return <WorkflowRunSteps />;
};

export default WorkflowRunStepsPage;
